import { createFileRoute } from "@tanstack/react-router";

import { RedirectByImei } from "/src/routes/person/redirectByImei/Redirect";

export const Route = createFileRoute("/_main/person/redirect")({
  component: RedirectByImei,
});
